import { render } from "./ReportNotFound.vue?vue&type=template&id=7615500f"
import script from "./ReportNotFound.vue?vue&type=script&lang=js"
export * from "./ReportNotFound.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__